import { DashboardTemplate } from "@modootoday/ui-widgets/templates";
import { PageHeader } from "@/shared/components";
import { KpiCards } from "./components/kpi-cards";
import { QuickActions } from "./components/quick-actions";
import { WeeklyTrend } from "./components/weekly-trend";
import { TopKeywords } from "./components/top-keywords";
import { DomainUsage } from "./components/domain-usage";
import { RecentAlerts } from "./components/recent-alerts";
import { ActivityFeed } from "./components/activity-feed";

export function DashboardPage() {
  return (
    <DashboardTemplate>
      <PageHeader
        title="대시보드"
        description="검색 마케팅 핵심 지표를 한눈에 확인하세요."
      />

      <KpiCards />
      <QuickActions />

      <div className="grid gap-6 xl:grid-cols-[1fr_360px]">
        <div className="space-y-6">
          <WeeklyTrend />
          <div className="grid gap-6 lg:grid-cols-2">
            <TopKeywords />
            <DomainUsage />
          </div>
        </div>
        <div className="space-y-6">
          <RecentAlerts />
          <ActivityFeed />
        </div>
      </div>
    </DashboardTemplate>
  );
}
